var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.1006 32C24.9371 32 32.1006 24.8366 32.1006 16C32.1006 7.16344 24.9371 0 16.1006 0C7.26403 0 0.100586 7.16344 0.100586 16C0.100586 24.8366 7.26403 32 16.1006 32Z",
    fill: "url(#paint0_linear_1846_32472)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1675 23.3332C12.6492 23.3332 12.7372 23.1375 12.5585 22.6439L11.0342 17.6273L22.7675 10.6665",
    fill: "#C8DAEA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.167 23.3335C13.567 23.3335 13.7437 23.1505 13.967 22.9335L16.1003 20.8591L13.4393 19.2544",
    fill: "#A9C9DD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4392 19.2547L19.8872 24.0185C20.623 24.4245 21.1541 24.2143 21.3373 23.3354L23.962 10.967C24.2307 9.88963 23.5513 9.40099 22.8474 9.72056L7.43542 15.6634C6.38341 16.0853 6.38954 16.6722 7.24366 16.9338L11.1987 18.1682L20.3551 12.3915C20.7874 12.1294 21.1841 12.2703 20.8585 12.5593",
    fill: "url(#paint1_linear_1846_32472)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1846_32472",
    x1: 21.435,
    y1: 5.3344,
    x2: 13.435,
    y2: 24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#37AEE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E96C8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1846_32472",
    x1: 17.2773,
    y1: 15.9998,
    x2: 18.9869,
    y2: 21.5298,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF7FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/Telegram.40815dc32eeb19b0da36c608718562a2.svg";
export { ForwardRef as ReactComponent };